import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Products from './components/Products';
import Banner from './components/Banner';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import SearchModal from './components/SearchModal';
import QuickView from './components/QuickView';

function App() {
  const [loading, setLoading] = useState(true);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [quickViewProduct, setQuickViewProduct] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const handleOpenSearch = () => setIsSearchOpen(true);
  const handleCloseSearch = () => setIsSearchOpen(false);
  
  const handleOpenQuickView = (product) => setQuickViewProduct(product);
  const handleCloseQuickView = () => setQuickViewProduct(null);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <div className="loading-logo">Sweet Atelier</div>
          <div className="loading-line"></div>
          <div className="loading-text">正在准备甜蜜...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Navigation onOpenSearch={handleOpenSearch} />
      <Hero />
      <Categories />
      <Products onOpenQuickView={handleOpenQuickView} />
      <Banner />
      <About />
      <Testimonials />
      <Footer />
      <SearchModal isOpen={isSearchOpen} onClose={handleCloseSearch} />
      <QuickView product={quickViewProduct} onClose={handleCloseQuickView} />
    </div>
  );
}

export default App;
